<ng-container *ngIf="showButtonType; else textType">
  <button
    *ngIf="!href; else anchorTpl"
    class="nav-list-button btn-nav-list"
    (click)="buttonClick()"
    [ngClass]="{ 'text-bold': showTextBold || isSelected, 'default-icon-color': defaultIconColor }"
    
    [disabled]="disabled"
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </button>
  <ng-template #anchorTpl>
    <a
      class="nav-list-button btn-nav-list"
      (click)="buttonClick()"
      [ngClass]="{
        'text-bold': showTextBold || isSelected,
        'default-icon-color': defaultIconColor,
        disabled: disabled
      }"
      
      [href]="href"
    >
      <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
    </a>
  </ng-template>
</ng-container>

<ng-template #buttonContent>
  <shrd-uic-text
    class="nav-list-button-label"
    [class.text-indent]="hasTextIndent && (!showIcon || (isSelected && hideIconOnSelect))"
    [ngClass]="additionalClasses"
  >
    <ng-container *ngIf="iconPosition === 'left'" icon-before>
      <ng-container *ngTemplateOutlet="iconContent"></ng-container>
    </ng-container>

    <span content>
      <ng-container *ngTemplateOutlet="textContent"></ng-container>
    </span>

    <ng-container *ngIf="iconPosition === 'right'" icon-after-1>
      <ng-container *ngTemplateOutlet="iconContent"></ng-container>
    </ng-container>
  </shrd-uic-text>
</ng-template>

<ng-template #textType>
  <shrd-uic-text
    class="text-bold nav-list-button-label"
    [ngClass]="{ 'text-indent': hasTextIndent }"
    
  >
    <span content>
      <ng-container *ngTemplateOutlet="textContent"></ng-container>
    </span>
  </shrd-uic-text>
</ng-template>

<ng-template #iconContent>
  <shrd-uic-svg-icon *ngIf="showIcon && !(isSelected && hideIconOnSelect)" [icon]="iconName"></shrd-uic-svg-icon>
</ng-template>

<ng-template #textContent>
  <ng-content></ng-content>
</ng-template>
